import { render, staticRenderFns } from "./Videocountchip.vue?vue&type=template&id=61de9b58"
import script from "./Videocountchip.vue?vue&type=script&lang=js"
export * from "./Videocountchip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports